"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_fontawesome_1 = require("@medely/react-fontawesome");
const Box_1 = __importDefault(require("@mui/material/Box"));
const react_1 = __importDefault(require("react"));
const COLORS = {
    // avoiding bringing theme into icons and causing circular dependencies
    primary: '#006877',
    textPrimary: '#252525',
    secondary: '#952A1F',
    textSecondary: '#808080',
    disabled: '#a8a8a8',
    warning: '#f6b80f',
    error: '#952A1F',
    info: '#0288d1',
    success: '#00A580', //palette.success.main
};
/**
 * @todo make this use the main color from the palette to set the icon color, and the
 * light color to set the background
 */
const FAIcon = ({ icon, htmlColor, bgcolor, small, ...props }) => {
    if (props.color) {
        // @ts-ignore
        props.color = COLORS[props.color];
    }
    else if (htmlColor) {
        props.color = htmlColor;
    }
    const width = small ? '32px' : '40px';
    const height = small ? '32px' : '40px';
    const padding = small ? 0 : 1;
    if (small) {
        props.height = '18px';
    }
    return bgcolor ? (react_1.default.createElement(Box_1.default, { sx: {
            width: width,
            height: height,
            borderRadius: '50%',
            bgcolor: bgcolor,
            padding: padding,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        } },
        react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: icon, ...props }))) : (react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: icon, ...props }));
};
exports.default = FAIcon;
